export const GET_ROLES = "GET_ROLES";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_USER_DETAILS_BY_CLIENTID = "GET_USER_DETAILS_BY_CLIENTID";
export const GET_CREATE_USER = "GET_CREATE_USER";
export const GET_UPDATE_USER = "GET_UPDATE_USER";
export const GET_UPDATE_USER_ACCESS = "GET_UPADATE_USER_ACCESS";
export const GET_UPDATE_USER_TO_ADMIN_OR_NOT = "GET_UPDATE_USER_TO_ADMIN_OR_NOT";
export const GET_USER_DETAILS_BY_TOKEN = "GET_USER_DETAILS_BY_TOKEN";
export const GET_ALL_USERS_UNDER_CLIENT_ADMIN = "GET_ALL_USERS_UNDER_CLIENT_ADMIN";
export const GET_UPDATE_USER_TNC_ACCEPTANCE = "GET_UPDATE_USER_TNC_ACCEPTANCE";
	
const ACTION_LOADER = "ACTION_LOADER";
const SET_ROLES = "SET_ROLES";
const SET_USER_DETAILS = "SET_USER_DETAILS";
const SET_USER_DETAILS_BY_CLIENTID = "SET_USER_DETAILS_BY_CLIENTID";
const SET_USER_DETAILS_BY_TOKEN = "SET_USER_DETAILS_BY_TOKEN";
const SET_CREATE_USER = "SET_CREATE_USER";
const SET_UPDATE_USER = "SETUPDATE_USER";
const SET_UPDATE_USER_ACCESS = "SET_UPADATE_USER_ACCESS";
const SET_UPDATE_USER_TO_ADMIN_OR_NOT = "SET_UPDATE_USER_TO_ADMIN_OR_NOT";
const SET_TNC_ACCEPTED = "SET_TNC_ACCEPTED";


export const getUserTncAcceptance = (payload) => {
	return {
		type: GET_UPDATE_USER_TNC_ACCEPTANCE,
		payload: payload
	}
}

export const getRoles = () => {
	return {
		type: GET_ROLES,
	};
};

export const setRoles = payload => {
	return {
		type: SET_ROLES,
		payload,
	};
};

export const getUserDetails = payload => {
	return {
		type: GET_USER_DETAILS,
		payload: payload,
	};
};

export const setUserDetails = payload => {
	return {
		type: SET_USER_DETAILS,
		payload: payload,
	};
};

export const getUserDetailsByClientId = payload => {
	return {
		type: GET_USER_DETAILS_BY_CLIENTID,
		payload,
	};
};

export const getUserDetailsByToken = () => {
	return {
		type: GET_USER_DETAILS_BY_TOKEN
	}
}

export const getUserDetailsUnderClientAdmin = () => {
	return {
		type: GET_ALL_USERS_UNDER_CLIENT_ADMIN
	}
}

export const setUserDetailsByClientId = payload => {
	return {
		type: SET_USER_DETAILS_BY_CLIENTID,
		payload,
	};
};

export const setUserDetailsByToken = payload => {
	return {
		type: SET_USER_DETAILS_BY_TOKEN,
		payload,
	};
};

export const createUser = payload => ({
	type: GET_CREATE_USER,
	payload,

});

export const setCreateUser = payload => {
	return {
		type: SET_CREATE_USER,
		payload,
	};
};

export const getUpdateUser = payload => {
	return {
		type: GET_UPDATE_USER,
		payload,
	};
};

export const setTnCAccepted = payload => {
	return {
		type: SET_TNC_ACCEPTED,
		payload
	}
}

export const setUpdateUser = payload => {
	return {
		type: SET_UPDATE_USER,
		payload,
	};
};

export const getUpdateUserAccess = payload => {
	return {
		type: GET_UPDATE_USER_ACCESS,
		payload,
	};
};

export const setUpdateUserAccess = payload => {
	return {
		type: SET_UPDATE_USER_ACCESS,
		payload,
	};
};

export const getUpdateUserToAdminOrNot = payload => {
	return {
		type: GET_UPDATE_USER_TO_ADMIN_OR_NOT,
		payload,
	};
};

export const setUpdateUserToAdminOrNot = payload => {
	return {
		type: SET_UPDATE_USER_TO_ADMIN_OR_NOT,
		payload,
	};
};

export const setLoaderState = loadingState => ({
	type: ACTION_LOADER,
	loadingState,
});


const initialState = {
	isUserLoading: "",
	roles: [],
	userDetails: [],
	loggedInUser: {},
	loggedInUserByToken: "",
	createdUserDetail: {},
	updatedUserDetail: {},
	updatedAdmin : {},
	updatedUserAccess : {},
	isTncAccepted: false,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_ROLES:
			return { ...state, roles: [...action.payload.items] };
		case SET_USER_DETAILS:
			return { ...state, loggedInUser: {...action.payload.item} };
		case SET_USER_DETAILS_BY_CLIENTID:
			return { ...state, userDetails: [ ...action.payload.items ] };
		case SET_USER_DETAILS_BY_TOKEN:
			return { ...state, loggedInUserByToken: {...action.payload.item} }
		case SET_CREATE_USER:
			return { ...state, createdUserDetail: {...action.payload} };
		case SET_UPDATE_USER:
			return { ...state, updatedUserDetail: {...action.payload} };
		case SET_UPDATE_USER_ACCESS:
			return { ...state, updatedUserAccess: {...action.payload} };
		case SET_UPDATE_USER_TO_ADMIN_OR_NOT:
			return { ...state, updatedAdmin: {...action.payload} };
		case ACTION_LOADER:
			const { loadingState } = action;
			return { ...state, isUserLoading: loadingState };
		case SET_TNC_ACCEPTED:
			return {...state, isTncAccepted: action.payload}
		default:
			return state;
	}
};
